
import TUIViewer from "../../components/application/TUIViewer.vue";
import {ComputedRef, defineComponent, onBeforeMount, onMounted, Ref, watch} from "vue";
import {useStore} from "vuex";
import {ExerciseStudent, Question} from "./helpers";
import {computed} from "@vue/reactivity";
import {questionErrorHandler} from "./questionnaire_error_handler";
import {useRouter} from "vue-router";
import {scrollParentToElement} from "../../utils/scroll";
import TUIEditor from "../../components/TUIEditor.vue";
import {ref} from "@vue/runtime-core";

export default defineComponent({
  name: "QuestionDescriptive",
  components: {TUIEditor, TUIViewer},
  setup() {
    const store = useStore();
    const router = useRouter();

    const answer: Ref<string> = ref("");
    const TUIEditorKey = ref(0)

    const question: ComputedRef<Question> = computed(() =>
        store.getters["content_module/questionnaire/currentQuestion"]);

    watch(question, () => onCurrentQuestionUpdate());

    onBeforeMount(() => {
      fillAnswerField();
    })

    const onCurrentQuestionUpdate = async (): Promise<void> => {
      try {
        await reloadQuestionControls();
        await updateQuestionPageOnURL();
        fillAnswerField();
        updateTUIEditor();
      } catch (e) {
        console.error("[onCurrentQuestionUpdate] Error ", e);
        await questionErrorHandler(e);
      }
    };

    const reloadQuestionControls = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/questionnaire/questionnaire_control/reload");
      } catch (e) {
        console.error("[reloadQuestionControls] Error ", e);
        throw e;
      }
    };

    const updateQuestionPageOnURL = async (): Promise<void> => {
      try {
        const currentRoute = router.currentRoute.value;
        if (!currentRoute) return;
        await router.push({
          name: currentRoute.name as string,
          params: {...currentRoute.params, page: question.value.page}
        });
      } catch (e) {
        console.error("[reloadQuestionControls] Error ", e);
        throw e;
      }
    };

    const fillAnswerField = (): void => {
      answer.value = question.value.status.answer;
    }

    const {isAbleToRedoQuestions}: ExerciseStudent = store.getters["content_module/exercise/exercise"];

    const onSubmit = async (): Promise<void> => {
      try {
        if (!isAbleToRedoQuestions && question.value.status.attempts > 0) return;
        if (question.value.attemptLimit !== null && question.value.status.attempts === question.value.attemptLimit) {
          return;
        }
        await replyQuestion();
        updateTUIEditor();
        scrollToFeedbackBanner();
      } catch (e) {
        console.error("[onSubmit] Error ", e);
        await questionErrorHandler(e);
      }
    }

    const replyQuestion = async (): Promise<void> => {
      try {
        const payload = {page: question.value.page, answer: answer.value};
        await store.dispatch("content_module/questionnaire/replyDescriptiveQuestionByPage", payload)
      } catch (e) {
        console.error("[replyQuestion] Error ", e);
        throw e;
      }
    };

    const updateTUIEditor = () => {
      TUIEditorKey.value++;
    };

    const scrollToFeedbackBanner = () => {
      const parentElement: HTMLElement | null = document.querySelector("[data-questionnaire-view]");
      const element: HTMLElement | null = document.querySelector("[data-feedback]");
      if (!parentElement || !element) {
        return
      }
      scrollParentToElement(parentElement, element, 500);
    };

    return {
      question,
      isAbleToRedoQuestions,
      answer,
      TUIEditorKey,
      onSubmit,
    }
  }
});
